import Head from "next/head";

interface NoIndexHeadProps {
    nofollow?: boolean;
}

/**
 * Robots directive for routes that must never be indexed, such as embeds and private links.
 * @param nofollow Whether crawlers should also ignore the links on the page
 * @returns The head fragment carrying the directive
 */
export function NoIndexHead({ nofollow = false }: NoIndexHeadProps) {
    return (
        <Head>
            <meta name="robots" content={nofollow ? "noindex, nofollow" : "noindex, follow"} />
        </Head>
    );
}
